import { t } from 'i18next'
import { ToastEventPayload } from '~/hooks/toast/useToastAlerts'
import {
  NotificationDomain,
  NotificationPayload,
} from '~/services/EventEmitter/types/NotificationEmitterTypes'

export enum VoicemailOperation {
  MoveVoicemail = 'moveVoicemail',
  DeleteVoicemail = 'deleteVoicemail',
  MarkAsUnread = 'markAsUnread',
}

export type VoicemailOperationContext = {
  [VoicemailOperation.MoveVoicemail]: {
    voicemailId: number
    newExtensionId: number
    markAsUnread: boolean
  }
  [VoicemailOperation.DeleteVoicemail]: {
    voicemailId: number
  }
  [VoicemailOperation.MarkAsUnread]: {
    voicemailId: number
  }
}

const getMoveVoicemailEvent = (
  payload: NotificationPayload<NotificationDomain.VOICEMAIL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('voicemail.move.success')
      break
    case 'red.solid':
      title = t('voicemail.move.error')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    description: payload.message,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

const getDeleteVoicemailEvent = (
  payload: NotificationPayload<NotificationDomain.VOICEMAIL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('global.toast.deleteSuccess')
      break
    case 'red.solid':
      title = t('global.toast.deleteError')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    description: payload.message,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

const getMarkAsUnreadEvent = (
  payload: NotificationPayload<NotificationDomain.VOICEMAIL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('global.toast.markUnreadSuccess')
      break
    case 'red.solid':
      title = t('global.toast.markUnreadError')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    description: payload.message,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

export const getVoicemailToastEvent = (
  payload: NotificationPayload<NotificationDomain.VOICEMAIL>,
) => {
  switch (payload.operation) {
    case VoicemailOperation.MoveVoicemail:
      return getMoveVoicemailEvent(payload)
    case VoicemailOperation.DeleteVoicemail:
      return getDeleteVoicemailEvent(payload)
    case VoicemailOperation.MarkAsUnread:
      return getMarkAsUnreadEvent(payload)
    default:
      return null
  }
}
